import * as React from "react";
import {
  SelectInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  TextInput,
  maxValue,
  minValue,
  NumberInput,
  BooleanInput,
} from "react-admin";
import { GAS_BRAND_MERCHANT_STATUSES } from "@local/app/constants/index.js";

const EditGasBrandMerchantInfo = () => (
  <>
    <BooleanInput source="partner_gas_brand" validate={[required()]} />
    <NumberInput
      sx={{ width: "14%" }}
      source="priority"
      min={0}
      max={32000}
      validate={[required(), minValue(0), maxValue(32000)]}
      defaultValue={0}
    />
  </>
);

const EditGasBrandMerchantFuel = () => (
  <ArrayInput
    source="fuels"
    sx={{
      width: "60%",
      "@media (max-width:1200px)": {
        width: "100%",
      },
    }}
    label=""
  >
    <SimpleFormIterator
      inline
      disableClear={true}
      disableReordering={true}
      disableRemove={true}
    >
      <TextInput
        source="name"
        label="resources.GasBrandMerchant.fuels.name"
        validate={[required()]}
        inputProps={{ maxLength: 55, minLength: 1 }}
      />
      <NumberInput
        sx={{
          width: "60%",
          "@media (max-width:1200px)": {
            width: "100%",
          },
        }}
        source="regular_price"
        label="resources.GasBrandMerchant.fuels.regular_price"
        validate={[required(), maxValue(2147483647), minValue(0)]}
      />
      <NumberInput
        sx={{
          width: "60%",
          "@media (max-width:1200px)": {
            width: "100%",
          },
        }}
        source="discount_price"
        label="resources.GasBrandMerchant.fuels.discount_price"
        validate={[required(), maxValue(2147483647), minValue(0)]}
      />
      <SelectInput
        sx={{
          width: "60%",
          "@media (max-width:1200px)": {
            width: "100%",
          },
        }}
        source="status"
        label="resources.GasBrandMerchant.fuels.status"
        validate={[required()]}
        choices={Object.keys(GAS_BRAND_MERCHANT_STATUSES).map((status) => {
          if (status === "blocked") {
            return "";
          }

          return {
            id: status,
            name: `resources.GasBrandMerchant.source.status.${status}`,
          };
        })}
      />
    </SimpleFormIterator>
  </ArrayInput>
);

export { EditGasBrandMerchantFuel, EditGasBrandMerchantInfo };
